const getDataUrlFromLang = (lang, langMapping) => {
  let dataUrl = '';
  if (langMapping instanceof Array) {
    const langForSelectedCity =
      typeof lang === 'string' ? lang.toLowerCase() : '';
    const data = langMapping.filter(item => {
      const langInLoop =
        typeof item.name === 'string' ? item.name.toLowerCase() : '';
      return langForSelectedCity === langInLoop;
    })[0];
    if (data && data.dataUrl) {
      dataUrl = data.dataUrl;
    }
  }
  return dataUrl;
};

export default getDataUrlFromLang;
